import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageTitle from "../components/common/PageTitle";

export default function Search() {
  const { t } = useTranslation();
  const params = new URLSearchParams(useLocation().search);
  const query = params.get("q")?.toLowerCase() || "";

  // Récupérer les FAQ multilingues depuis i18n
  const faqData = t("getHelp.questionsSearch", { returnObjects: true });

  // Définir les index de séparation (adapter selon la structure réelle)
  // Ici, on suppose que les 20 premières sont ETA-IL, le reste eVisa-B2
  const etaIlFaq = faqData.slice(0, 20);
  const evisaFaq = faqData.slice(20);

  // Fonction pour surligner les termes de recherche
  const highlightText = (text) => {
    if (!query || !text) return text;
    
    // Diviser la requête en mots individuels
    const searchWords = query.split(/\s+/).filter(word => word.length > 0);
    
    let highlightedText = text;
    
    // Surligner chaque mot de la recherche
    searchWords.forEach(word => {
      const regex = new RegExp(`(${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
      const parts = highlightedText.split(regex);
      
      highlightedText = parts.map((part, index) => 
        regex.test(part) ? (
          <mark key={`${word}-${index}`} style={{ backgroundColor: '#ffeb3b', padding: '2px 4px', borderRadius: '3px' }}>
            {part}
          </mark>
        ) : part
      );
    });
    
    return highlightedText;
  };

  // Filtrer selon la recherche
  const filterFaq = arr => arr.filter(
    q =>
      q.question.toLowerCase().includes(query) ||
      q.answer.toLowerCase().includes(query)
  );

  const etaIlResults = filterFaq(etaIlFaq);
  const evisaResults = filterFaq(evisaFaq);
  const hasResults = etaIlResults.length > 0 || evisaResults.length > 0;

  return (
    <div style={{ maxWidth: "1200px", margin: "40px auto", padding: 24 }}>
      <PageTitle pageKey="search" titleKey="pageTitles.search" fallbackTitle={t("search.title")} />
      <h1>{t("search.title")}</h1>
      <p>{t("search.query", "Recherche")} : <strong>{query}</strong></p>
      {!hasResults ? (
        <p>{t("search.noResults", "Aucun résultat trouvé.")}</p>
      ) : (
        <>
          {etaIlResults.length > 0 && (
            <div style={{ marginBottom: 32 }}>
              <h2>ETA-IL</h2>
              <ul style={{ listStyle: "none", padding: 0 }}>
                {etaIlResults.map((q, i) => (
                  <li key={i} style={{ marginBottom: 24 }}>
                    <strong>{highlightText(q.question)}</strong>
                    <div>{highlightText(q.answer)}</div>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {evisaResults.length > 0 && (
            <div style={{ marginBottom: 32 }}>
              <h2>eVisa-B2</h2>
              <ul style={{ listStyle: "none", padding: 0 }}>
                {evisaResults.map((q, i) => (
                  <li key={i} style={{ marginBottom: 24 }}>
                    <strong>{highlightText(q.question)}</strong>
                    <div>{highlightText(q.answer)}</div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      )}
    </div>
  );
} 